<mat-card>
    <mat-card-header>
        <mat-card-title>Cadastrar Funcionário</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content>
        <form [formGroup]="funcionarioForm">
            <div class="row">
                <div class="col-auto">
                    <h1 class="customH1">Informações Gerais</h1>
                </div>
                <div class="col-sm">
                    <hr />
                </div>
            </div>

            <div class="borda">

                <div class="row">
                    <div class="col-sm-4">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Nome</mat-label>
                            <input type="text" matInput formControlName="nome" required maxlength="100">
                            <mat-error *ngIf="f.nome.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-2">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>CPF</mat-label>
                            <input type="text" matInput formControlName="cpf" required maxlength="100"
                                [textMask]="{mask: maskCPF, guide:false}">
                            <mat-error *ngIf="f.cpf.errors?.required">
                                Campo obrigatório
                            </mat-error>
                            <mat-error *ngIf="f.cpf.errors?.cpfValido">
                                CPF inválido
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Telefone</mat-label>
                            <input type="text" matInput formControlName="telefone" [textMask]="{mask: maskTelefone}"
                                (ngModelChange)="onChangeTel($event, true)" required>
                            <mat-error *ngIf="f.telefone.errors?.required">
                                Campo obrigatório
                            </mat-error>
                            <mat-error *ngIf="f.telefone.errors?.telefoneValido">
                                Telefone inválido
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Telefone Secundário</mat-label>
                            <input type="text" matInput formControlName="telefoneSecundario"
                                [textMask]="{mask: maskTelefone2}" (ngModelChange)="onChangeTel($event, false)">
                        </mat-form-field>
                    </div>

                    <div class="col-2" *ngIf="f.bVender.value">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Comissão</mat-label>
                            <input type="number" matInput formControlName="comissao">
                            <span matSuffix>
                                %
                            </span>
                        </mat-form-field>
                    </div>
                </div>

            </div>

            <div class="row mt-4">
                <div class="col-auto">
                    <h1 class="customH1">Permissões</h1>
                </div>
                <div class="col-sm">
                    <hr />
                </div>
            </div>

            <div class="borda">
                <div class="row">
                    <div class="col-auto">
                        <ul>
                            <li class="tituloLi">
                                <mat-checkbox formControlName="bTodosCadastro" [labelPosition]="'before'"
                                    (click)="allCheck('Cadastrar')" [color]="'warn'"
                                    (keyup.space)="allCheck('Cadastrar')">
                                    Cadastrar</mat-checkbox>
                            </li>
                            <div class="bordaLista">
                                <li>
                                    <mat-checkbox formControlName="bRealizarCadastroClientes" [color]="'primary'">
                                        Clientes</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bRealizarCadastroFornecedores"
                                        [color]="'primary'">
                                        Fornecedores</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bRealizarCadastroFuncionarios"
                                        [color]="'primary'">
                                        Funcionários</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bRealizarCadastroGrupos" [color]="'primary'">
                                        Grupos</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bRealizarCadastroProdutos" [color]="'primary'">
                                        Produtos</mat-checkbox>
                                </li>
                            </div>
                        </ul>
                    </div>

                    <div class="col-auto">
                        <ul>
                            <li class="tituloLi">
                                <mat-checkbox formControlName="bTodosConsulta" [labelPosition]="'before'"
                                    (click)="allCheck('Consultar')" [color]="'warn'" (change)="checkAlterado()"
                                    (keyup.space)="allCheck('Consultar')">
                                    Consultar</mat-checkbox>
                            </li>
                            <div class="bordaLista">
                                <li>
                                    <mat-checkbox formControlName="bRealizarConsultaClientes" [color]="'primary'"
                                        (change)="checkAlterado()">
                                        Clientes</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bRealizarConsultaFornecedores"
                                        [color]="'primary'" (change)="checkAlterado()">
                                        Fornecedores</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bRealizarConsultaFuncionarios"
                                        [color]="'primary'" (change)="checkAlterado()">
                                        Funcionários</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bRealizarConsultaGrupos" [color]="'primary'"
                                        (change)="checkAlterado()">
                                        Grupos</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bRealizarConsultaProdutos" [color]="'primary'"
                                        (change)="checkAlterado()">
                                        Produtos</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bRealizarConsultaLogs" [color]="'primary'"
                                        (change)="checkAlterado()">
                                        Log's</mat-checkbox>
                                </li>
                            </div>
                        </ul>
                    </div>

                    <div class="col-auto">
                        <ul>
                            <li class="tituloLi">
                                <mat-checkbox formControlName="bTodosAlterar" [labelPosition]="'before'"
                                    (click)="allCheck('Alterar')" [color]="'warn'" (keyup.space)="allCheck('Alterar')">
                                    Alterar</mat-checkbox>
                            </li>
                            <div class="bordaLista">
                                <li>
                                    <mat-checkbox formControlName="bAlterarClientes" [color]="'primary'">
                                        Clientes</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bAlterarFornecedores"
                                        [color]="'primary'">
                                        Fornecedores</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bAlterarFuncionarios"
                                        [color]="'primary'">
                                        Funcionários</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bAlterarGrupos" [color]="'primary'">
                                        Grupos</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bAlterarProdutos" [color]="'primary'"
                                        (change)="checkAlterado()">
                                        Produtos</mat-checkbox>
                                </li>
                            </div>
                        </ul>
                    </div>

                    <div class="col-auto">
                        <ul>
                            <li class="tituloLi">
                                <mat-checkbox formControlName="bTodosExcluir" [labelPosition]="'before'"
                                    (click)="allCheck('Excluir')" [color]="'warn'" (keyup.space)="allCheck('Excluir')">
                                    Excluir</mat-checkbox>
                            </li>
                            <div class="bordaLista">
                                <li>
                                    <mat-checkbox formControlName="bExcluirVendas" [color]="'primary'">
                                        Venda</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bExcluirProdutos"
                                        [color]="'primary'">
                                        Produtos</mat-checkbox>
                                </li>
                            </div>
                        </ul>
                    </div>

                    <div class="col-auto">
                        <ul>
                            <li class="tituloLi">
                                <mat-checkbox formControlName="bTodosDemaisFuncoes" [labelPosition]="'before'"
                                    (click)="allCheck('DemaisFuncoes')" [color]="'warn'"
                                    (keyup.space)="allCheck('DemaisFuncoes')">
                                    Demais funcões</mat-checkbox>
                            </li>
                            <div class="bordaLista">
                                <li>
                                    <mat-checkbox formControlName="bVender" [color]="'primary'">
                                        Vender</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bGerente" [color]="'primary'">
                                        Gerente</mat-checkbox>
                                </li>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>

            <div *ngIf="f.bGerente.value">
                <div class="row mt-4">
                    <div class="col-auto">
                        <h1 class="customH1">Senha Administrativa</h1>
                    </div>
                    <div class="col-sm">
                        <hr />
                    </div>
                </div>

                <div class="borda">
                    <div class="row">
                        <div class="col-3">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Senha</mat-label>
                                <input type="{{inputTypePass2}}" matInput formControlName="senhaAdministrativa"
                                    autocomplete="new-password" required minlength="8" maxlength="16">
                                <button type="button" mat-button matSuffix mat-icon-button (click)="exibirSenha(false)">
                                    <mat-icon>{{iconeSenha2}}</mat-icon>
                                </button>
                                <mat-error *ngIf="f.senhaAdministrativa.errors?.required">
                                    Campo obrigatório
                                </mat-error>
                                <mat-error *ngIf="f.senhaAdministrativa.errors?.min">
                                    O mínimo são 8 caracteres
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-auto">
                    <h1 class="customH1">Informações de Acesso</h1>
                </div>
                <div class="col-sm">
                    <hr />
                </div>
            </div>

            <div class="borda">
                <div class="row">
                    <div class="col-4">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Email</mat-label>
                            <input type="text" matInput formControlName="email" autocomplete="email" required
                                maxlength="100">
                            <mat-error *ngIf="f.email.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-3">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Senha</mat-label>
                            <input type="{{inputTypePass}}" matInput formControlName="senha" autocomplete="new-password"
                                required maxlength="20">
                            <button type="button" mat-button matSuffix mat-icon-button (click)="exibirSenha(true)">
                                <mat-icon>{{iconeSenha}}</mat-icon>
                            </button>
                            <mat-error *ngIf="f.senha.errors?.required">
                                Campo obrigatório
                            </mat-error>
                            <mat-error *ngIf="f.senha.errors?.min">
                                O mínimo são 8 caracteres
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>
    </mat-card-content>

    <mat-divider></mat-divider>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
        <button mat-flat-button color="warn" (click)="limparCampos()">
            <mat-icon>clear</mat-icon> Limpar Campos
        </button>
        <button mat-flat-button color="primary" (click)="cadastrar()">
            <mat-icon>check</mat-icon> Cadastrar
        </button>
    </section>
</mat-card>